<twc-trowser [caption]="'VOLUME_REPORT.HEADER' | translate" class="dialog-project" [class.isSite]="isSite"
    [class.isDownload]="isDownload" [closable]="!isDownload">

    <twc-trowser-content #reportInit class="trowser-content" [class.twc-pb-3]="isDownload"
        *ngIf="!loading; else loadingTemplate">

        <div class="report-data">
            <div class="report-block" *ngIf="report?.createdOn">
                <div class="header">
                    <span>{{'VOLUME_REPORT.CREATED_ON' | translate: {date: report?.createdOn} }}</span>
                </div>
            </div>

            <div class="report-block">
                <div class="report-line">
                    <span [class.topcon-blue]="!isDownload" flex="30">{{'VOLUME_REPORT.PROJECT_NAME' |
                        translate}}</span>
                    <span>{{projectName}}</span>
                </div>
                <div class="report-line">
                    <span [class.topcon-blue]="!isDownload" flex="30">{{'VOLUME_REPORT.VOLUME_NAME' | translate}}</span>
                    <span>{{reportFormatted.name}}</span>
                </div>
                <div class="report-line" *ngIf="reportFormatted.designSurface">
                    <span [class.topcon-blue]="!isDownload" flex="30">{{'SCANPROC.DESIGN_SURFACE' | translate}}</span>
                    <span>{{reportFormatted.designSurface}}</span>
                </div>
                <div class="report-line" *ngIf="reportFormatted.existingSurface">
                    <span [class.topcon-blue]="!isDownload" flex="30">{{'SCANPROC.EXISTING_SURFACE' | translate}}</span>
                    <span>{{reportFormatted.existingSurface}}</span>
                </div>
            </div>

            <div class="report-block">
                <div class="report-block-header header">
                    <h3 [class.topcon-blue]="!isDownload">{{'VOLUME_REPORT.VOLUME' | translate}}</h3>
                </div>
                <div class="report-line">
                    <span [class.topcon-blue]="!isDownload">{{'VOLUME_REPORT.CUT_VOLUME' | translate}}</span>
                    <span>{{reportFormatted.cutVolume}}</span>
                </div>
                <div class="report-line">
                    <span [class.topcon-blue]="!isDownload">{{'VOLUME_REPORT.FILL_VOLUME' | translate}}</span>
                    <span>{{reportFormatted.fillVolume}}</span>
                </div>
                <div class="report-line">
                    <span [class.topcon-blue]="!isDownload">{{'VOLUME_REPORT.TOTAL_VOLUME' | translate}}</span>
                    <span>{{reportFormatted.totalVolume}}</span>
                </div>
            </div>

            <div class="report-block">
                <div class="block-header header">
                    <h3 [class.topcon-blue]="!isDownload">{{'VOLUME_REPORT.AREA' | translate}}</h3>
                </div>
                <div class="report-line">
                    <span [class.topcon-blue]="!isDownload">{{'VOLUME_REPORT.CUT_AREA' | translate}}</span>
                    <span>{{reportFormatted.cutArea}}</span>
                </div>
                <div class="report-line">
                    <span [class.topcon-blue]="!isDownload">{{'VOLUME_REPORT.FILL_AREA' | translate}}</span>
                    <span>{{reportFormatted.fillArea}}</span>
                </div>
                <div class="report-line">
                    <span [class.topcon-blue]="!isDownload">{{'VOLUME_REPORT.TOTAL_AREA' | translate}}</span>
                    <span>{{reportFormatted.totalArea}}</span>
                </div>
            </div>

            <div class="report-block">
                <div class="block-header header">
                    <h3 [class.topcon-blue]="!isDownload">{{'VOLUME_REPORT.SETTINGS' | translate}}</h3>
                </div>
                <div class="report-line">
                    <span [class.topcon-blue]="!isDownload">{{'SCANPROC.CALC_METHOD' | translate}}</span>
                    <span>{{reportFormatted.calculationMethod}}</span>
                </div>
                <div class="report-line">
                    <span [class.topcon-blue]="!isDownload">{{'SCANPROC.DESIGN_PLANE' | translate}}</span>
                    <span>{{reportFormatted.designPlaneSettings}}</span>
                </div>
                <div class="report-line">
                    <span [class.topcon-blue]="!isDownload">{{'VOLUME_REPORT.GROUND_SAMPLE_DISTANCE' |
                        translate}}</span>
                    <span>{{reportFormatted.groundSampleDistance}}</span>
                </div>
                <div class="report-line">
                    <span [class.topcon-blue]="!isDownload">{{'SCANPROC.ORIGIN_COORDINATES' | translate}}</span>
                    <span>{{reportFormatted.originPointCoordinates}}</span>
                </div>
                <div class="report-line">
                    <span [class.topcon-blue]="!isDownload">{{'SCANPROC.HEIGHT_CORNER' | translate}}</span>
                    <span>{{reportFormatted.requiredHeightCornerCount}}</span>
                </div>
            </div>
        </div>
        <div *ngIf="isSite && hasScreenshotImages" class="report-screenshots twc-p-3">
            <img *ngIf="volumeScreenshotUrl" src="{{volumeScreenshotUrl}}"
                alt="{{'VOLUME_REPORT.VOLUME_ALT_LABEL' | translate}}" />
            <img *ngIf="pointCloudScreenshotUrl" src="{{pointCloudScreenshotUrl}}"
                alt="{{'VOLUME_REPORT.POINTCLOUD_ALT_LABEL' | translate}}" />
        </div>

    </twc-trowser-content>

    <twc-trowser-footer *ngIf="!isDownload">

        <button *ngIf="!isSite" class="twc-button twc-button-primary" [disabled]="loading" (click)="onDownloadText()">
            {{'EXPORT_LAYER_DIALOG.DOWNLOAD' | translate}}
        </button>

        <twc-menu-wrapper *ngIf="isSite" #menuWrapper>
            <button class="twc-button twc-button-primary" [disabled]="loading" twcMenuTrigger>
                <span class="twc-button-label">{{'EXPORT_LAYER_DIALOG.DOWNLOAD' | translate}}</span>
                <twc-icon [shape]="menuWrapper.isShown ? 'drop-down' : 'drop-up'" [size]="32"></twc-icon>
            </button>
            <twc-menu [position]="'top'" class="twc-mb-1 formats-menu">
                <twc-menu-option (click)="onDownloadHTML()">
                    {{'VOLUME_REPORT.DOWNLOAD_FORMATS.HTML' | translate}}
                </twc-menu-option>
                <twc-menu-option (click)="onDownloadCsv()">
                    {{'VOLUME_REPORT.DOWNLOAD_FORMATS.CSV' | translate}}
                </twc-menu-option>
                <twc-menu-option (click)=" onDownloadText()">
                    {{'VOLUME_REPORT.DOWNLOAD_FORMATS.TXT' | translate}}
                </twc-menu-option>
            </twc-menu>
        </twc-menu-wrapper>
    </twc-trowser-footer>

</twc-trowser>

<ng-template #loadingTemplate>
    <div class="loader width-100 height-100 twc-d-flex twc-row-center justify-content-center">
        <twc-loader size="large"></twc-loader>
    </div>
</ng-template>